"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCarouselAtTheEnd = void 0;
var _constants = require("../constants");
/** Checks if Carousel is at the end and last slide is visible.
 * if `progress` is `NaN` Carousel has no scrolling and all slides are visible.
 * if `progress` is greater than LAST_SLIDE_TRESHOLD last slide is visible and Carousel is at the end.
 *
 * @param progress the number that shows in which part of Carousel we are (0 = start, 0.5 = in the half, 1 = at the end).
 * @returns the boolean, it's true when Carousel is at the end and last slide is visible.
 */
const isCarouselAtTheEnd = progress => Number.isNaN(progress) || progress > _constants.LAST_SLIDE_THRESHOLD;
exports.isCarouselAtTheEnd = isCarouselAtTheEnd;
//# sourceMappingURL=isCarouselAtTheEnd.js.map